import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import BidView from '@/views/BidView.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/bid',
    name: 'Bid',
    component: BidView
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
